import {ChangeDetectionStrategy, Component, OnInit} from '@angular/core';
import {take} from 'rxjs/operators';
import {Quality} from '../../../engine/playable/qualities';
import {Hotkeys} from '../../../modules/hotkeys/hotkeys.enum';
import {HotkeysService} from '../../../modules/hotkeys/hotkeys.service';
import {Store} from '@ngxs/store';
import {SeekToLive, SelectQuality, SetVolume, ToggleMute, TogglePlay} from '../../../store/player.actions';
import {PlayerState} from '../../../store/player.state';

@Component({
  selector: 'gg-buttons-bar',
  templateUrl: './buttons-bar.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ButtonsBarComponent implements OnInit {
  public isPlaying$ = this.store.select(state => state.player.isPlaying);
  public volume$ = this.store.select(state => state.player.volume);
  public isLive$ = this.store.select(state => state.player.isLive);
  public qualities$ = this.store.select(state => state.player.qualities);
  public currentQuality$ = this.store.select(state => state.player.currentQuality);

  constructor(private store: Store, hotkeysService: HotkeysService) {

    hotkeysService.on(Hotkeys.togglePlay).subscribe(() => this.playClick());
    hotkeysService.on(Hotkeys.toggleMute).subscribe(() => this.toggleMute());
    hotkeysService.on(Hotkeys.goToLive).subscribe(() => this.seekToLive());
    hotkeysService.on(Hotkeys.volumeUp).subscribe(() => this.volumeUp());
    hotkeysService.on(Hotkeys.volumeDown).subscribe(() => this.volumeDown());

  }

  ngOnInit() {
  }

  playClick() {
    this.store.dispatch(new TogglePlay());
  }

  toggleMute() {
    this.store.dispatch(new ToggleMute());
  }

  setVolume(volume: number) {
    this.store.dispatch(new SetVolume({volume}));
  }

  switchToQuality(quality: Quality) {
    this.store.dispatch(new SelectQuality({quality}));
    // this.store.dispatch(new TogglePlay());
  }

  seekToLive() {
    this.store.dispatch(new SeekToLive());
  }

  async volumeUp() {
    const currentVolume = await this.volume$.pipe(take(1)).toPromise();
    this.setVolume(currentVolume + 5);
  }

  async volumeDown() {
    const currentVolume = await this.volume$.pipe(take(1)).toPromise();
    this.setVolume(currentVolume - 5);
  }

}
